/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
export const FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES = 'FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES'
export const FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES_SUCCESS = 'FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES_SUCCESS'
export const FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES_FAILURE = 'FETCH_GLOBAL_AND_PERSONAL_USER_PREFERENCES_FAILURE'


export const CREATE_USER_PREFERENCES = 'CREATE_USER_PREFERENCES'
export const CREATE_USER_PREFERENCES_SUCCESS = 'CREATE_USER_PREFERENCES_SUCCESS'
export const CREATE_USER_PREFERENCES_FAILURE = 'CREATE_USER_PREFERENCES_FAILURE'


export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES'
export const UPDATE_USER_PREFERENCES_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS'
export const UPDATE_USER_PREFERENCES_FAILURE = 'UPDATE_USER_PREFERENCES_FAILURE'


export const SETDEFAULTVIEW_USER_PREFERENCES = 'SETDEFAULTVIEW_USER_PREFERENCES'
export const SETDEFAULTVIEW_USER_PREFERENCES_SUCCESS = 'SETDEFAULTVIEW_USER_PREFERENCES_SUCCESS'
export const SETDEFAULTVIEW_USER_PREFERENCES_FAILURE = 'SETDEFAULTVIEW_USER_PREFERENCES_FAILURE'


export const DELETE_USER_PREFERENCES = 'DELETE_USER_PREFERENCES'
export const DELETE_USER_PREFERENCES_SUCCESS = 'DELETE_USER_PREFERENCES_SUCCESS'
export const DELETE_USER_PREFERENCES_FAILURE = 'DELETE_USER_PREFERENCES_FAILURE'

export const FETCH_ACCOUNT_USER_PREFERENCES = 'FETCH_ACCOUNT_USER_PREFERENCES'
export const FETCH_ACCOUNT_USER_PREFERENCES_SUCCESS = 'FETCH_ACCOUNT_USER_PREFERENCES_SUCCESS'
export const FETCH_ACCOUNT_USER_PREFERENCES_FAILURE = 'FETCH_ACCOUNT_USER_PREFERENCES_FAILURE'

export const RESET_STORE="RESET_STORE"


